import React from 'react';
import moment from 'moment';

import { clearDrinks } from '../actions/drinks';
import { untilString, diffMS } from '../util';

import DrinkListItem from './drink-list-item';

export default (props) => {

  const { drinks, startTimestamp, finishTimestamp } = props;
  console.log(props);

  const sd = Math.ceil(props.sd * 10) / 10;
  const first = moment(startTimestamp).format('h:mm a');
  const feedTime = moment(finishTimestamp).format('h:mm a');
  const until = diffMS(finishTimestamp);
  const untilSentence = untilString(finishTimestamp);

  console.log({
    first,
    feedTime,
    until,
  });


  return (
    <div className="view drinks">
      <header>
        <h1>Your Drinks</h1>
      </header>
      {until ? (
        <div className="feed-at-summary">
          <p className="drinks-sentence">You can safely feed in</p>
          <p className="drinks-sentence--highlight">{untilSentence}</p>
          <p className="drinks-sentence">at {feedTime}.</p>
        </div>
      ) : (
        <div className="feed-at-summary">
          <p className="drinks-sentence--safe">It's now safe for you to breastfeed.</p>
        </div>
      )}
      <p className="drinks-sentence">You've had</p>
      <p className="drinks-sentence--highlight">{sd} standard drinks</p>
      <p className="drinks-sentence">since {first}.</p>


      <div className="drink-list">
        {drinks.map(drink => <DrinkListItem key={drink.timestamp} {...drink} />)}
      </div>

      <p>
        <button className="btn secondary" onClick={clearDrinks}>Clear All</button>
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/drinks.js